$(document).ready(function() {
  const count_carousel_items = ($("#carouselProjectPictures .carousel-item").length);
  const carousel_prev_control = $("#carouselProjectPictures .carousel-control-prev");
  const carousel_next_control = $("#carouselProjectPictures .carousel-control-next");
  const modale_prev_control = $("#modalCarouselProjectPictures .carousel-control-prev");
  const modale_next_control = $("#modalCarouselProjectPictures .carousel-control-next");

  if (count_carousel_items <= 1) {
    carousel_prev_control.addClass("d-none")
    carousel_next_control.addClass("d-none")
    modale_prev_control.addClass("d-none")
    modale_next_control.addClass("d-none")
  }
});
